document.addEventListener('DOMContentLoaded', function () {
  const menuDrawer = document.querySelector('.menu-drawer');
  const menuOverlay = document.querySelector('.menu-overlay');

  // Initially hide the menu and overlay
  menuDrawer.style.left = '-100%';
  menuDrawer.style.height = '100vh';
  menuOverlay.style.display = 'none';
  menuOverlay.style.height = '100vh';
  menuOverlay.style.opacity = '0';

  const openButton = document.querySelector('.open-button');
  const closeButton = document.querySelector('.close-button');

  openButton.addEventListener('click', function () {
    // Existing event listener code...
  });

  closeButton.addEventListener('click', function () {
    // Existing event listener code...
  });

  menuOverlay.addEventListener('click', function () {
    // Existing event listener code...
  });

  // Additional code to handle window load event
  window.addEventListener('load', function () {
    // Hide the preloader when the window fully loads
    const preloader = document.getElementById('preloader');
    preloader.style.display = 'none';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.querySelector('.open-button');
  const closeButton = document.querySelector('.close-button');
  const menuDrawer = document.querySelector('.menu-drawer');
  const menuOverlay = document.querySelector('.menu-overlay');

  // Initially hide the menu and overlay
  menuDrawer.style.left = '-100%';
  menuOverlay.style.display = 'none';
  menuOverlay.style.opacity = '0';

  openButton.addEventListener('click', function () {
    menuDrawer.style.left = '0';
    menuOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';

    // Gradually increase the opacity of the overlay
    setTimeout(function () {
      menuOverlay.style.opacity = '0.5';
    }, 10);
  });

  closeButton.addEventListener('click', function () {
    menuDrawer.style.left = '-100%';

    menuOverlay.style.opacity = '0';

    setTimeout(function () {
      menuOverlay.style.display = 'none';
      document.body.style.overflow = 'auto';
    }, 300);
  });

  menuOverlay.addEventListener('click', function () {
    menuDrawer.style.left = '-100%';

    menuOverlay.style.opacity = '0';

    setTimeout(function () {
      menuOverlay.style.display = 'none';
      document.body.style.overflow = 'auto';
    }, 300);
  });


  window.addEventListener('load', function () {
    // Ensure the menu and overlay are hidden when the window fully loads
    menuDrawer.style.left = '-100%';
    menuDrawer.style.height = '100vh';
    menuOverlay.style.display = 'none';
    menuOverlay.style.height = '100vh';
    menuOverlay.style.opacity = '0';
    document.body.style.overflow = 'auto';
  });
});

